<template>
  <div class="quality-setting">
    <m-table-list ref="tableList" :isPage="false" :fetch-list-func="fetchListFunc">
      <template v-slot:page-title>
        <div class="table-header">
          <div class="add-setting-btn">
            <span @click="showDialog">+添加质检项</span>
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column label="质检项目名称" prop="qaTestTypeName"></el-table-column>
        <el-table-column label="质检分数（所有项目合计为：100分）" prop="score"></el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="{row}">
            <el-button type="text" size="small" @click="deleteItem(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </m-table-list>

    <el-dialog title="请设置质检项目" @close="handleDialogClose" :visible.sync="dialogTableVisible">
      <div class="dialog-main-content">
        <p>总共100分，{{ leftScore >= 0 ? `还可设置${leftScore}分` : `超出${-leftScore}分` }}</p>
        <div class="create-form">
          <div v-for="(item,index) in qualityItemList" :key="index" class="quality-item">
            <div class="quality-name">
              <span>质检项目名称</span>
              <el-input v-model.trim="item.qaTestTypeName" maxlength="10" placeholder="项目名称不超过10字"></el-input>
            </div>
            <div class="quality-score">
              <span>质检项目分数</span>
              <el-input v-model.number="item.score" oninput="value=value.replace(/[^0-9.]/g,'')" maxLength="3"
                        placeholder="加起来100分"></el-input>
            </div>
            <i class="el-icon-circle-close" @click="removeItem(index)"></i>
          </div>
        </div>
        <el-button @click="addQualityItem">添加额外的质检项目</el-button>
      </div>
      <div class="btn-box">
        <el-button size="small" @click="handleDialogClose">取消</el-button>
        <el-button style="color: #fff;background: #1890ff;"  size="small" @click="createQualityDic">确认添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";
import card from 'components/card'

export default {
  name: "workmange.workQualitySetting.setting",
  components: {
    "m-table-list": tableList,
    "m-card": card
  },
  data() {
    return {
      qualityItemList: [],
      dialogTableVisible: false,
      tableScore: 100,
      tempLeftScore:100
    }
  },
  computed: {
    leftScore() {
      let tempScore = this.tableScore
      for (let item of this.qualityItemList) {
        const score = item.score ? item.score : 0
        tempScore -= score
      }
      return tempScore
    }
  },
  activated() {
    this.initDialog()
  },
  methods: {
    fetchListFunc: api.workmanage.getQaTestDictList,
    deleteItem(id) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass:'confirmBtn',
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.workmanage.DeleteQaTestDict(id).then(() => {
          this.$message.success('删除成功！')
          this.$refs.tableList.getMainData();
        })
      })
    },
    createQualityDic() {
      if (this.leftScore<0) {
        this.$message.warning('超出设置总分，请重新设置分数！')
        return
      }
      const tempArr = this.qualityItemList.filter(item => item.qaTestTypeName || item.score)
      if (tempArr.length===0) {
        this.$message.warning('请填写数据！')
        return
      }
      for (let item of tempArr) {
        if (!item.qaTestTypeName) {
          this.$message.warning('请设置质检名称！')
          return
        }else if (!item.score) {
          this.$message.warning(`请设置${item.qaTestTypeName}的质检分数！`)
          return
        }
      }
      api.workmanage.createQaTestDict(tempArr).then(res => {
        this.handleDialogClose()
        this.$refs.tableList.getMainData();
      })
    },
    addQualityItem() {
      this.qualityItemList.push({
        qaTestTypeName: undefined,
        score: undefined
      })
    },
    initDialog() {
      for (let i = 0; i < 3; i++) {
        this.qualityItemList.push({
          qaTestTypeName: undefined,
          score: undefined
        })
      }
    },
    removeItem(i) {
      this.qualityItemList.splice(i,1)
    },
    handleDialogClose() {
      this.dialogTableVisible = false
      this.qualityItemList = []
      this.initDialog()
      this.tableScore = 100
    },
    showDialog() {
      this.dialogTableVisible = true
      for (let item of this.$refs.tableList.mainData.rows) {
        this.tableScore -= item.score
      }
    }
  }
}
</script>

<style lang="less" scoped>
.quality-setting {
  width: 100%;
  height: 936px;

  .table-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 24px;

    .add-setting-btn {
      font-size: 16px;
      color: #3572E2;
      cursor: pointer;
    }
  }
}

/deep/ .el-dialog {
  width: 750px;

  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .el-dialog__body {
    padding: 0;

    .dialog-main-content {
      padding: 9px 24px 15px;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
      border-bottom: 1px solid rgba(0, 0, 0, 0.09);

      p {
        text-align: right;
        margin-bottom: 13px;
      }

      .create-form {

        .quality-item {
          display: flex;
          justify-content: space-around;
          margin-bottom: 10px;

          span {
            margin-right: 12px;
          }

          i{
            font-size: 18px;
            line-height: 40px;
            cursor: pointer;
          }
          p{
            margin: 5px 0 0 100px;
            color: red;
            font-size: 12px;
          }
        }
      }

      .el-input {
        width: 220px;
      }
    }

    .btn-box {
      display: flex;
      justify-content: flex-end;
      padding: 20px 23px 26px;

      .cancel-btn {
        border-radius: 2px;
      }

      .confirm-btn {
        color: #fff;
        background: #1890ff;
        border-radius: 2px;
      }

    }


  }
}

</style>